//export const VITE_API_URL = "http://192.168.1.27:3000"
export const VITE_API_URL = "https://api.infinityjackpot.net"
export const VITE_WS_PROVIDER = "wss://xode-polkadot-rpc-01.zeeve.net/y0yxg038wn1fncc/rpc"
export const VITE_OPERATOR_ADDRESS = "XqBYKruUCPfDreq6U5YtqS4H7PMtntwVGDXEwtcunDmTzXguV"
export const VITE_WEB_SOCKET_URL = "wss://api.infinityjackpot.net/lottery-jobs"
//export const VITE_WEB_SOCKET_URL = "ws://192.168.1.27:3000/lottery-jobs"
export const VITE_BET_AMOUNT = '0.5'